// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 获取当前用户的 customerId GET /api/customer/info */
export async function currentUser(options?: { [key: string]: any }) {
  return request<{
    code?: number;
    msg?: string;
    data?: {
      customerId?: string,
      uid?: string
      uname?: string
    };
  }>('/api/customer/info', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 退出登录接口 POST /auth/logout */
export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/oms/auth/logout', {
    method: 'POST',
    baseURL: '',
    ...(options || {}),
  });
}

/** 登录接口 POST /auth/login */
export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  return request<API.LoginResult>('/auth/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** SSO浏览器自动登录接口 POST /internal/sso/browser-token */
export async function ssoBrowserLogin(
  userid: number,
  headers: Record<string, string>,
  options?: { [key: string]: any },
) {
  return request<API.LoginResult>('/internal/sso/browser-token', {
    method: 'POST',
    params: { userid },
    headers,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>('/api/rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rule', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}

